import React, { useEffect, useState } from 'react'
import heroBanner from '../assets/images/hero-banner.png';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import blog1 from '../assets/images/blog-1.png';
import arrowup from '../assets/images/arrow-up-right.svg';
import profile1 from '../assets/images/profile1.png';
import blog2 from '../assets/images/blog-2.png';
import blogavtr2 from '../assets/images/blog-avtar2.png';
import blog3 from '../assets/images/blog-3.png';
import blogavtr3 from '../assets/images/blog-avtar3.png';
import connectionbanner from '../assets/images/connection-banner.png';
import { Link } from 'react-router-dom';
import '../styles/bubbles.css';
import '../styles/style.css';


function Blog() {
 
  return (
   
      <>
      {/* <!-- preloader end  -->
      <!-- Mouse Cursor Start -->   */}
      <div className="mouse-cursor cursor-outer"></div>
      <div className="mouse-cursor cursor-inner"></div>
      <header className="top-header inner-banner" style={{background: `url(${heroBanner}) no-repeat top center`}}>
         
         <div id="stars"></div>
         <div id="stars2"></div>
         <div id="stars3"></div>
         <Navbar/>
         <section className="banner-caption flex-center">
            <div className="caption-header text-white">
               <div className="container text-center">
                  <h1 className="caption-title"> Stay Updated with Our Blog </h1>
               </div>
            </div>
         </section>
      </header>
      {/* <!-- /Blog Details Section --> */}

      <section className="blog py-5">
         <div className="container">
           <div className="row pt-5">

             <div className="col-lg-4">
               <div className="blog-container shadow mb-4">
                 <div className="blog-banner card-image">
                   <img src={blog1} alt="Blog banner" className="img-fluid blog-img" />
                 </div>
                 <div className="blog-content">
                   <div className="blog-item-name">Design</div>
                   <div className="blog-title py-3">
                     <h1> The Future of Enterprise Technology Integration </h1>
                   </div>
                   <div className="blog-body-content mb-3">
                     <p className="mb-0"> Explore how emerging technologies like AI and machine learning are shaping the future of enterprise technology. Discover how businesses can stay competitive by adopting these cutting-edge solutions. </p>
                   </div>
                   <Link to="blog-detail.html" className="blog-link">Read More <span>
                       <img src={arrowup} alt="arrow-up" />
                     </span>
                   </Link> 
                 </div>
                 <div className="blog-footer d-flex pt-5 pb-2">
                   <div className="profile me-3">
                     <img src={profile1} alt="Blog profile" className="img-fluid" />
                   </div>
                   <div className="profile-desc">
                     <p>Olivia Rhye</p>
                     <span className="blog-date">20 Jan 2022</span>
                   </div>
                 </div>
               </div>
             </div>
             <div className="col-lg-4">
               <div className="blog-container shadow mb-4">
                 <div className="blog-banner card-image">
                   <img src={blog2} alt="Blog banner" className="img-fluid blog-img" />
                 </div>
                 <div className="blog-content">
                   <div className="blog-item-name">Product</div>
                   <div className="blog-title py-3">
                     <h1> Case Study: Successful <br />System Integration for a Global Retailer </h1>
                   </div>
                   <div className="blog-body-content mb-3">
                     <p className="mb-0"> Linear helps streamline software projects, sprints, tasks, and bug tracking. Here’s how to get started. </p>
                   </div>
                   <Link to="blog-detail.html" className="blog-link">Read More <span>
                       <img src={arrowup} alt="arrow-up" />
                     </span>
                   </Link> 
                 </div>
                 <div className="blog-footer d-flex pt-5 pb-2">
                   <div className="profile me-3">
                     <img src={blogavtr2} alt="Blog profile" className="img-fluid" />
                   </div>
                   <div className="profile-desc">
                     <p>Phoenix Baker</p>
                     <span className="blog-date">19 Jan 2022</span>
                   </div>
                 </div>
               </div>
             </div>
             <div className="col-lg-4">
               <div className="blog-container shadow mb-4">
                 <div className="blog-banner card-image">
                   <img src={blog3} alt="Blog banner" className="img-fluid blog-img" />
                 </div>
                 <div className="blog-content">
                   <div className="blog-item-name"> Software Engineering </div>
                   <div className="blog-title py-3">
                     <h1> Top 5 Challenges in Data Integration and How to Overcome Them </h1>
                   </div>
                   <div className="blog-body-content mb-3">
                     <p className="mb-0"> Data integration can be complex, but with the right strategies, it’s possible to overcome common challenges. Read our guide on navigating the pitfalls and ensuring seamless data unification. </p>
                   </div>
                   <Link to="blog-detail.html" className="blog-link">Read More <span>
                       <img src={arrowup} alt="arrow-up" />
                     </span>
                   </Link> 
                 </div>
                 <div className="blog-footer d-flex pt-5 pb-2">
                   <div className="profile me-3">
                     <img src={blogavtr3} alt="Blog profile" className="img-fluid" />
                   </div>
                   <div className="profile-desc">
                     <p>Lana Steiner</p>
                     <span className="blog-date">18 Jan 2022</span>
                   </div>
                 </div>
               </div>
             </div>

             <div className="col-lg-4">
               <div className="blog-container shadow mb-4">
                 <div className="blog-banner card-image">
                   <img src={blog1} alt="Blog banner" className="img-fluid blog-img" />
                 </div>
                 <div className="blog-content">
                   <div className="blog-item-name">Design</div>
                   <div className="blog-title py-3">
                     <h1> The Future of Enterprise Technology Integration </h1>
                   </div>
                   <div className="blog-body-content mb-3">
                     <p className="mb-0"> Explore how emerging technologies like AI and machine learning are shaping the future of enterprise technology. Discover how businesses can stay competitive by adopting these cutting-edge solutions. </p>
                   </div>
                   <Link to="blog-detail.html" className="blog-link">Read More <span>
                       <img src={arrowup} alt="arrow-up" />
                     </span>
                   </Link> 
                 </div>
                 <div className="blog-footer d-flex pt-5 pb-2">
                   <div className="profile me-3">
                     <img src={profile1} alt="Blog profile" className="img-fluid" />
                   </div>
                   <div className="profile-desc">
                     <p>Olivia Rhye</p>
                     <span className="blog-date">20 Jan 2022</span>
                   </div>
                 </div>
               </div>
             </div>

             <div className="col-lg-4">
               <div className="blog-container shadow mb-4">
                 <div className="blog-banner card-image">
                   <img src={blog2} alt="Blog banner" className="img-fluid blog-img" />
                 </div>
                 <div className="blog-content">
                   <div className="blog-item-name">Product</div>
                   <div className="blog-title py-3">
                     <h1> Case Study: Successful <br />System Integration for a Global Retailer </h1>
                   </div>
                   <div className="blog-body-content mb-3">
                     <p className="mb-0"> Linear helps streamline software projects, sprints, tasks, and bug tracking. Here’s how to get started. </p>
                   </div>
                   <Link to="blog-detail.html" className="blog-link">Read More <span>
                       <img src={arrowup} alt="arrow-up" />
                     </span>
                   </Link> 
                 </div>
                 <div className="blog-footer d-flex pt-5 pb-2">
                   <div className="profile me-3">
                     <img src={blogavtr2} alt="Blog profile" className="img-fluid" />
                   </div>
                   <div className="profile-desc">
                     <p>Phoenix Baker</p>
                     <span className="blog-date">19 Jan 2022</span>
                   </div>
                 </div>
               </div>
             </div>

             <div className="col-lg-4">
               <div className="blog-container shadow mb-4">
                 <div className="blog-banner card-image">
                   <img src={blog3} alt="Blog banner" className="img-fluid blog-img" />
                 </div>
                 <div className="blog-content">
                   <div className="blog-item-name"> Software Engineering </div>
                   <div className="blog-title py-3">
                     <h1> Top 5 Challenges in Data Integration and How to Overcome Them </h1>
                   </div>
                   <div className="blog-body-content mb-3">
                     <p className="mb-0"> Data integration can be complex, but with the right strategies, it’s possible to overcome common challenges. Read our guide on navigating the pitfalls and ensuring seamless data unification. </p>
                   </div>
                   <Link to="blog-detail.html" className="blog-link">Read More <span>
                       <img src={arrowup} alt="arrow-up" />
                     </span>
                   </Link> 
                 </div>
                 <div className="blog-footer d-flex pt-5 pb-2">
                   <div className="profile me-3">
                     <img src={blogavtr3} alt="Blog profile" className="img-fluid" />
                   </div>
                   <div className="profile-desc">
                     <p>Lana Steiner</p>
                     <span className="blog-date">18 Jan 2022</span>
                   </div>
                 </div>
               </div>
             </div>

           </div>

           <div className="row">
            <div className="col-12 text-center">
               <div className="pagination mt-5">
                  <Link to="#"><i className="uil-arrow-left"></i></Link> 
                  <Link to="#">1</Link> 
                  <Link to="#" className="active">2</Link> 
                  <Link to="#">3</Link> 
                  <Link to="#">4</Link> 
                  <Link to="#"><i className="uil-arrow-right"></i></Link> 
                </div>
             </div>
           </div>


         </div>
       </section>

      <section className="bottom-bg py-5">
         <div className="container">
            <div className="row">
               <div className="col-lg-12">
                  <div className="dark-bg-block">
                     <div className="tech-integration d-flex align-items-center">
                        <div className="col-lg-5">
                           <div className="contact-info-block text-white">
                              <h1 className="head-medium"> Let’s Build Something Great Together </h1>
                              <p className="py-4"> Got a question or a project in mind? We're here to help. Reach out today, and let's discuss how we can integrate the perfect technology solutions for your business needs. Your next step toward innovation starts here. </p>
                           </div>
                        </div>
                        <div className="col">
                           <div className="connection-banner d-flex justify-content-end">
                              <img src={connectionbanner} alt="Integration banner" className="img-fluid" />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
      {/* <!-- footer --> */}
   <Footer/>
      <div className="progress-wrap">
         <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
         </svg>
      </div>
   
      <Helmet>
      <title>Entegation Technologies | Blog</title>
      <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.8/slick.min.css"/>
      <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.8/slick-theme.min.css"/>
        <script src="/assets/js/script.js"></script>  
      <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.9/slick.min.js"></script>
      <script src="/assets/js/carousel.js"></script>
      <script src="/assets/js/script.js"></script>
      <script src="/assets/js/form.js"></script>
    </Helmet>

    </>
  
  )
}

export default Blog